<template>
  <div class="">
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Select to Export Report</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-main-section">
      <div class="columns is-multiline">
        <!-- <div class="column is-3" v-if="modules.ledger">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <router-link :to="{ name: 'LedgerReportDetails' }" title="Ledger Report">
                <b-icon class="has-text-warning m-t-15" icon="briefcase" size="is-large"> </b-icon>
                <p class="subtitle is-5 has-text-black m-t-25">Ledger Report</p>
              </router-link>
            </div>
          </div>
        </div> -->

        <!-- <div class="column is-3" v-if="modules.order">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <router-link :to="{ name: 'OrderReportDetails' }" title="Order Report">
                <b-icon class="has-text-warning m-t-15" icon="cart-outline" size="is-large"> </b-icon>
                <p class="subtitle is-5 has-text-black m-t-25">Order Report</p>
              </router-link>
            </div>
          </div>
        </div> -->
        <div class="column is-3" v-if="modules.royalty">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <router-link :to="{ name: 'RoyaltyReportDetails' }" title="Royalty Report">
                <b-icon class="has-text-warning m-t-15" icon="square-inc-cash" size="is-large"> </b-icon>
                <p class="subtitle is-5 has-text-black m-t-25">Royalty Report</p>
              </router-link>
            </div>
          </div>
        </div>

        <!-- <div class="column is-3" v-if="modules.orderProductsDetails">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <router-link :to="{ name: 'OrderPurchaseReportDetails' }" title="Order Product Report">
                <b-icon class="has-text-warning m-t-15" icon="coin" size="is-large"> </b-icon>
                <p class="subtitle is-5 has-text-black m-t-25">Order Product Details</p>
              </router-link>
            </div>
          </div>
        </div> -->
        <div class="column is-3" v-if="modules.tatsReport">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <router-link :to="{ name: 'OrderTatsReport' }" title="Order Tats Report">
                <b-icon class="has-text-warning m-t-15" icon="chart-pie" size="is-large"> </b-icon>
                <p class="subtitle is-5 has-text-black m-t-25">Order TAT Report</p>
              </router-link>
              <div>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>

        <div class="column is-3" v-if="modules.opsReport">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <b-icon classstudentConcession="has-text-centered m-t-15" icon="cash-multiple" size="is-large"> </b-icon>
              <p class="subtitle is-5 has-text-black m-t-25">Ops Report</p>
              <b-button @click="enableModal(opsReport)" type="is-primary" size="is-small" icon-left="briefcase-download">Export </b-button>
            </div>
          </div>
        </div>
        <!-- <div class="column is-3" v-if="modules.b2BReport">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <b-icon classstudentConcession="has-text-warning m-t-15" icon="chart-bar" size="is-large"> </b-icon>
              <p class="subtitle is-5 has-text-black m-t-25">B2B Order Report</p>
              <b-button @click="downloadCSVFile('b2bReport')" type="is-primary" size="is-small" icon-left="briefcase-download">Export </b-button>
            </div>
          </div>
        </div> -->
        <!-- <div class="column is-3" v-if="modules.studentConcession">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <b-icon class="has-text-warning m-t-15" icon="coin" size="is-large"> </b-icon>
              <p class="subtitle is-5 has-text-black m-t-24">Student Concession</p>
              <b-button @click="downloadCSVFile('studentConcession')" type="is-primary" size="is-small" icon-left="briefcase-download">Export </b-button>
            </div>
          </div>
        </div> -->
        <!-- <div class="column is-3" v-if="modules.leadSourceReport">
          <div class="box">
            <div class="has-text-centered p-b-10">
              <b-icon class="has-text-warning m-t-15" icon="contacts" size="is-large"> </b-icon>
              <p class="subtitle is-5 has-text-black m-t-24">Lead Source Report</p>
              <b-button @click="enableModal(leadSourceReport)" type="is-primary" size="is-small" icon-left="briefcase-download">Export </b-button>
            </div>
          </div>
        </div> -->
      </div>

      <div class="modal" :class="{ 'is-active': isModalActive }">
        <form class="modal-card" style="width:45rem;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              <strong> {{ selectedReportTypeForModal === opsReport ? 'Ops Report' : 'Lead Source Report' }} </strong>
            </p>
            <button class="delete" type="button" @click.prevent="closeModal()"></button>
          </header>
          <form @submit.prevent="downloadCSVFile(selectedReportTypeForModal)">
            <section class="modal-card-body">
              <div class="field" v-if="selectedReportTypeForModal === opsReport">
                <div class="control">
                  <label class="label">Report Type<span class="has-text-danger">* </span> </label>
                  <span class="select is-fullwidth">
                    <select required v-model="selectedOpsReportType">
                      <option value="" selected>---Select---</option>
                      <option :value="opsReportTypes[key]" v-for="key in Object.keys(opsReportTypes)" :key="key">{{ opsReportTypes[key] }}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="field" v-if="selectedReportTypeForModal === opsReport">
                <div class="control">
                  <label class="label">Franchisee<span class="has-text-danger">* </span> </label>
                  <span class="select is-fullwidth">
                    <select required v-model="franchiseeID">
                      <option selected value="">---Select---</option>
                      <option :value="franchisee.id" v-for="franchisee in franchiseeArr" :key="franchisee.id">{{ franchisee.companyName }}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="field" v-if="selectedReportTypeForModal !== opsReport">
                <div class="control">
                  <label class="label">Franchisee<span class="has-text-danger">* </span> </label>
                  <span class="select is-fullwidth">
                    <select v-model="franchiseeID">
                      <option value="" selected>---All Franchisee---</option>
                      <option :value="franchisee.id" v-for="franchisee in franchiseeArr" :key="franchisee.id">{{ franchisee.companyName }}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="field">
                <label class="label"
                  >Select Academic Year <span class="has-text-danger">* </span>
                  <b-icon icon="mdi mdi-calendar-check" type="is-primary" size="is-small"></b-icon>
                </label>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select name="academicYear" v-model="academicYearID" required>
                      <option disabled value>--Select--</option>
                      <option :value="year.id" v-for="year in academicYears" :key="year.id"> {{ year.academicYear }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button is-info m-r-10" type="submit">Download Report</button>
            </footer>
          </form>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
// import moment from 'moment'
// @ is an alias to /src
import constants from '@/utils/constants'
import ExportUtility from '@/utils/exportUtility'
import Utils from '@/utils'

import moment from 'moment'
export default {
  data () {
    return {
      ledgerData: [],
      franchiseeID: '',
      loadingComponent: null,
      fName: null,
      franchiseeArr: [],
      academicYears: [],
      academicYearID: null,
      isModalActive: false,
      currentAcademicYear: '',
      opsReportTypes: constants.OPSReportType,
      selectedOpsReportType: '',
      opsReport: 'opsReport',
      leadSourceReport: 'leadSourceReport',
      selectedReportTypeForModal: '',
      modules: {
        orderProductsDetails: this.checkModuleAccess('OrderProductsDetails'),
        studentConcession: this.checkModuleAccess('StudentConcession'),
        b2BReport: this.checkModuleAccess('B2BReport'),
        royalty: this.checkModuleAccess('Royalty'),
        order: this.checkModuleAccess('Order'),
        ledger: this.checkModuleAccess('Ledger'),
        tatsReport: this.checkModuleAccess('TATReport'),
        opsReport: this.checkModuleAccess('OPSReport'),
        leadSourceReport: this.checkModuleAccess('LeadSourceReport')
      }
    }
  },

  async created () {
    await this.getFranchiseeList()
    await this.getAcademicYears()
  },

  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    closeModal () {
      this.selectedReportTypeForModal = ''
      this.selectedOpsReportType = ''
      this.franchiseeID = ''
      this.academicYearID = this.currentAcademicYear ? this.currentAcademicYear.id : ''
      this.isModalActive = false
    },
    enableModal (selectedReportType) {
      this.selectedReportTypeForModal = selectedReportType
      this.isModalActive = true
    },
    getAcademicYears: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        this.flag = false
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        this.loadingComponent.close()
        this.currentAcademicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = this.currentAcademicYear ? this.currentAcademicYear.id : ''
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchiseeArr = data.rows
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    downloadCSVFile: async function (reportType) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        switch (reportType) {
          case 'b2bReport':
            this.fName = 'B2BReport'
            const b2bReport = await http.get(`${constants.API_URL}/api/b2b-order/report`)
            if (b2bReport.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = b2bReport.data
            break

          case 'studentConcession':
            this.fName = 'Concession'
            const consessionReport = await http.get(`${constants.API_URL}/api/student-concession/report`)
            if (consessionReport.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = consessionReport.data
            break
          case 'opsReport':
            if (!this.selectedOpsReportType) {
              return this.$buefy.toast.open({
                message: 'Report Type is required!',
                type: 'is-danger',
                duration: 4000
              })
            }
            if (!this.franchiseeID) {
              return this.$buefy.toast.open({
                message: 'Franchisee is required!',
                type: 'is-danger',
                duration: 4000
              })
            }
            if (!this.academicYearID) {
              return this.$buefy.toast.open({
                message: 'AcademicYear is required!',
                type: 'is-danger',
                duration: 4000
              })
            }
            let data = {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYearID
            }
            let result = []
            switch (this.selectedOpsReportType) {
              case this.opsReportTypes.AllKits:
                this.fName = 'OpsReport-allKits_'
                const opsReport = await http.get(`${constants.API_URL}/api/ops/report`, {
                  params: data
                })
                result = opsReport.data
                break

              case this.opsReportTypes.DamagedKit:
                this.fName = 'OpsReport-damagedKits_'
                const damagedKitOpsReport = await http.get(`${constants.API_URL}/api/report/ops/damaged-kit`, {
                  params: data
                })
                result = damagedKitOpsReport.data
                break

              default:
                return this.$buefy.toast.open({
                  message: 'Invalid report Type!',
                  type: 'is-danger',
                  duration: 4000
                })
            }
            if (result.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = result
            break
          case 'leadSourceReport':
            let leadsourceData = {
              franchiseeID: null,
              academicYearID: null
            }
            if (this.franchiseeID) {
              leadsourceData.franchiseeID = Number(this.franchiseeID) || null
            }

            if (!this.academicYearID) {
              return this.$buefy.toast.open({
                message: 'AcademicYear is required!',
                type: 'is-danger',
                duration: 4000
              })
            }

            leadsourceData.academicYearID = this.academicYearID
            this.fName = 'LeadSourceReport_'
            const opsReport = await http.get(`${constants.API_URL}/api/report/lead-source`, {
              params: leadsourceData
            })
            result = opsReport.data
            this.ledgerData = result
            break
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
      this.fName = this.fName + `${moment().format('DD-MM-YYYY')}`
      ExportUtility.convertToCsv(this.ledgerData, this.fName)
    }
  }
}
</script>
<style scoped>
.box {
  background-color: rgba(25, 29, 56, 0.25);
}
</style>
